const quotationPrefixInputs = document.querySelectorAll(".js-quotation-prefix-input");

for (const quotationPrefixInput of quotationPrefixInputs) {
  quotationPrefixInput.addEventListener("input", (ev) => {
    const prefixValue = ev.target.value.trim();
    const popup = ev.target.closest(".js-quotation-creation-popup");
    const previewInput = popup.querySelector(".js-quotation-preview-input");

    if (!popup || !previewInput) return;

    const rawSequences = popup.dataset.quotationSequences;
    const sequences = JSON.parse(rawSequences);
    const matchingSequence = sequences.find((el) => el.prefix === prefixValue);

    // If prefix exists, show next number in sequence
    // Otherwise, use a default value
    if (matchingSequence) {
      const nextNumber = (matchingSequence.sequence + 1).toString().padStart(5, "0");
      previewInput.value = `${prefixValue}-${nextNumber}`;
    } else if (prefixValue === "") {
      previewInput.value = "00001";
    } else {
      previewInput.value = `${prefixValue}-00001`;
    }
  });
}
